export const routeTitles = {
  // ---------- OnBoarding ----------
  "/onboarding": "شاین",

  // ---------- Common ----------
  "/login": "ورود / شاین",
  "/search": "جستجو / شاین",
  "/feedback": "بازخورد / شاین",
  "/payment/callback": "نتیجه پرداخت / شاین",

  // ---------- Store ----------
  "/store": "خانه / شاین",
  "/store/selection": "انتخاب فروشگاه / شاین",
  "/store/:id/info": "اطلاعات فروشگاه / شاین",
  "/store/:id": "فروشگاه / شاین",

  // ---------- Categories ----------
  "/categories": "دسته‌بندی‌ها / شاین",
  "/categories/single/:id": "دسته‌بندی / شاین",

  // ---------- Products ----------
  "/products/single/:id": "محصول / شاین",
  "/products/compare": "مقایسه محصولات / شاین",

  // ---------- Cart ----------
  "/cart": "سبد خرید / شاین",
  "/cart/single/:id": "سبد خرید / شاین",

  // ---------- Checkout ----------
  "/checkout/delivery-time": "زمان ارسال / شاین",
  "/checkout/payment": "پرداخت / شاین",

  // ---------- Profile ----------
  "/profile": "پروفایل / شاین",
  "/profile/address/create": "افزودن آدرس / شاین",
  "/profile/address/edit/:id": "ویرایش آدرس / شاین",
  "/profile/address": "آدرس‌ها / شاین",
  "/profile/user-account": "حساب کاربری / شاین",
  "/profile/wallet": "کیف پول / شاین",
  "/profile/order-history/single/:id/return": "مرجوعی سفارش / شاین",
  "/profile/order-history/single/:id": "جزئیات سفارش / شاین",
  "/profile/order-history": "سفارش‌ها / شاین",
  "/profile/payment-history": "تراکنش‌ها / شاین",
};
